import { useCallback, useContext, useState, useRef, useEffect } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { ModalContext } from "../../../store/modal-context";
import constants from './../../../store/constants.json';

const ModalRunPipeline = (props) => {
  const branchesInput = useRef();
  const exclusiveInput = useRef();
  const selectEnv = useRef();
  const selectProjects = useRef(null);
  const modalCtx = useContext(ModalContext);
  // console.log('modalCtx: ', modalCtx);
  const [branches, setBranches] = useState();
  const [branche, setBranche] = useState('');
  // Keeping isAllBranches for potential future use, but commenting it out to avoid ESLint warning
  // const [isAllBranches, setAllBranches] = useState(false);
  const [isExclusive, setExclusive] = useState(false);
  // Keeping exclusiveBranche for potential future use, but commenting it out to avoid ESLint warning
  // const [exclusiveBranche, setExclusiveBranche] = useState('');
  const [groupsValues, setGroupsValues] = useState([]);
  const [variables, setVariables] = useState();
  const environments = constants.environments;
  const projects = constants.projects;
  // const environments = modalCtx.environments;

  // Commented out unused function to avoid ESLint warning
  // const switchBranchesAutomation = () => {
  //   setAllBranches(false);
  // };

  const switchBranchesExclusive = () => {
    // setAllBranches(true);
  };

  const getBranches = useCallback(async (brancheName) => {
    const url = (isExclusive && selectProjects.current?.selectedIndex)
      ? `${modalCtx.gitlabProjectsUrl}${selectProjects.current[selectProjects.current?.selectedIndex].id}`
      : modalCtx.gitlabUrlAutomation;
      
    return fetch(`${url}/repository/branches${brancheName ? '?search=' + brancheName : ''}`, {
      headers: {
        'PRIVATE-TOKEN': modalCtx.PAT,
        'Accept': 'application/json',
      }
    })
    .then((response) => (response) && response.json())
    .then((result) => result.sort((a, b) => { return b.created_at - a.created_at; }).map((branche) => {return branche.name}))
    .then((branchesArray) => setBranches(branchesArray));
  }, [isExclusive, modalCtx.gitlabProjectsUrl, modalCtx.gitlabUrlAutomation, modalCtx.PAT]);

  const createPipeline = useCallback(async () => {
    let options = `ref=${branchesInput.current.value}&`;
    options += `variables[][key]=MICRO_URL_FRONTEND_COMMERCEOS&variables[][value]=${selectEnv.current.value}&`;
    options += `variables[][key]=DOMAIN_TEST&variables[][value]=${selectEnv.current[selectEnv.current.selectedIndex].dataset.domain}&`;
    options += `variables[][key]=CI_GROUP&variables[][value]=${groupsValues.join(', ')}&`;
    options += `variables[][key]=IN_PIPELINE_TYPE&variables[][value]=qa`;
    console.log('options', options);
    
    return fetch(`${modalCtx.gitlabUrlAutomation}/pipeline?${options}`, {
    // return fetch(`${modalCtx.gitlabUrlAutomation}/pipeline?ref=${branchesInput.current.value}&variables[][key]=MICRO_URL_FRONTEND_COMMERCEOS&variables[][value]=${selectEnv.current.value}&variables[][key]=DOMAIN_TEST&variables[][value]=${selectEnv.current[selectEnv.current.selectedIndex].dataset.domain}&variables[][key]=CI_GROUP&variables[][value]=${groupsValues.join(', ')}&variables[][key]=IN_PIPELINE_TYPE&variables[][value]=qa`, {
      method: 'post',
      headers: {
        'PRIVATE-TOKEN': modalCtx.PAT,
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data',
      },
      // body: {
      //   "ref": "refs/heads/" + branchesInput.current.value,
      //   "variables_attributes": variables,
      // }
    })
    .then((response) => (response) && console.log(response.json()));
    // .then((result) => result.sort((a, b) => { return b.created_at - a.created_at; }).map((branche) => {return branche.name}))
    // .then((branchesArray) => setBranches(branchesArray));
    // .then(console.log('branches: ', branches));
    // .then((result) => console.log('branches: ', result.map((branch) => {return branch.name})));
  }, [groupsValues, modalCtx.gitlabUrlAutomation, modalCtx.PAT]);

  const handleCheckox = (groupValue) => {
    let groupsState = groupsValues;
    if (groupsState.some((group) => group === groupValue)) {
      groupsState = groupsState.filter((group) => group !== groupValue);
    } else {
      groupsState.push(groupValue);
    }
 
    // groupsState = groupsState.join(', ');

    setGroupsValues(groupsState);
  }

  const handleRunPipeline = () => {
    // setBranche(branchesInput.current.value);

    const variablesArray = [
      {
        "variable_type": "env_var",
        key: "MICRO_URL_FRONTEND_COMMERCEOS",
        secret_value: selectEnv.current.value
      },
      {
        "variable_type": "env_var",
        key: "DOMAIN_TEST",
        secret_value: selectEnv.current[selectEnv.current.selectedIndex].dataset.domain
      },
      {
        "variable_type": "env_var",
        key: "CI_GROUP",
        secret_value: groupsValues.join(', ')
      },
      {
        "variable_type": "env_var",
        key: "IN_PIPELINE_TYPE",
        secret_value: 'qa'
      },
    ];

    setVariables(variablesArray);
  
    console.log('variables: ', variablesArray);
    createPipeline(variables);
    
    modalCtx.handleCloseModal();
    setGroupsValues([]);
    // setBranche('');
  }

  const searchBranches = () => {
    if (!isExclusive) {
      console.log('Pipelines branches!');
      if (branchesInput.current.value.length > 1) {
        setBranche(branchesInput.current.value);
        getBranches(branchesInput.current.value);
        console.log('branche', branche);
      } else {
        setBranche('');
      }
    } else {
      console.log('Exclusive branches!');
      if (exclusiveInput.current.value.length > 1) {
        // setExclusiveBranche(exclusiveInput.current.value);
        getBranches(exclusiveInput.current.value);
        console.log('branche', branche);
      }
    }
  }

  const showExclusiveForm = () => {
    setExclusive(selectEnv.current[selectEnv.current.selectedIndex].dataset.exclusive);
  }
  
  useEffect(() => {
    getBranches(branche);
  }, [getBranches, branche, isExclusive]);
  
  return (
    <>
      <Modal show={modalCtx.showModal} onHide={modalCtx.handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Run new pipeline</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row className="flex-column">
            <Col className="mb-4">
              <label htmlFor="branchesDataList" className="form-label fw-bold">
                Branch in Automation
              </label>
              <input
                className="form-control"
                list="branchesOptions"
                id="branchesDataList"
                placeholder="Type to search..."
                ref={branchesInput}
                // onClick={switchBranchesAutomation}
                onChange={searchBranches}
                onKeyDown={searchBranches}
              />
              <datalist id="branchesOptions">
                {/* {console.log('branches', branches)} */}

                {branches &&
                  branches.map((branch) => {
                    return <option key={branch} value={branch} />;
                  })}
                ;
              </datalist>
            </Col>
          </Row>

          <Row className="flex-column">
            <Col className="mb-4">
              <Form.Label className="fw-bold">Environment</Form.Label>
              <Form.Select
                aria-label="Environments" ref={selectEnv}
                onChange={showExclusiveForm}
              >
                <option
                  key={`key_select_default`}
                  data-exclusive={false}
                >--- Select Environment ---
                </option>

                {environments && environments.map((env) => {
                  return <option
                      key={`key_${env.name}`}
                      value={env.value}
                      data-domain={env.domain}
                      data-exclusive={(env.name === 'exclusive') ? true : false}
                    >{env.name.toUpperCase()}</option>;
                })}
              </Form.Select>
            </Col>
          </Row>

          <Row className={`flex-column ${(selectEnv.current?.selectedIndex && selectEnv.current[selectEnv.current.selectedIndex].dataset.exclusive === "true") ? '' : 'd-none'}`}>
            <Col className="mb-4">
              <Form.Label className="fw-bold">Project</Form.Label>
              <Form.Select aria-label="Projects" ref={selectProjects} >
                <option>--- Select Project ---</option>
                {/* {console.log('projects', projects)} */}

                {projects && Object.keys(projects).map((project) => {
                  return <option key={`key_${projects[project].id}`} id={projects[project].id}>{projects[project].name.toUpperCase()}</option>;
                })}
              </Form.Select>
            </Col>

            <Col className="mb-4">
              <label htmlFor="branchesExclusive" className="form-label fw-bold">
                Exclusive Branch
              </label>

              <input
                className="form-control"
                list="branchesOptions"
                id="branchesDataList"
                placeholder="Type to search..."
                ref={exclusiveInput}
                onClick={switchBranchesExclusive}
                onChange={searchBranches}
                onKeyDown={searchBranches}
              />
            </Col>
          </Row>

          <Row className="flex-column">
            <Col className="mb-4">
              <Form.Label className="fw-bold">Groups</Form.Label>
              <div className="column__groups">
                {modalCtx.groupsArray.map((group) => {
                  return (
                    <div key={`checkbox-${group.name.toLowerCase()}`} className="mb-3">
                      <Form.Check type={"checkbox"} id={`check-api-${group.name.toLowerCase()}`}>
                        <Form.Check.Input type={"checkbox"} value={group.value} onChange={() => {handleCheckox(group.value)}} isValid />
                        <Form.Check.Label>{group.name}</Form.Check.Label>
                      </Form.Check>
                    </div>
                  );
                })}
              </div>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={handleRunPipeline}>
            Run Pipeline
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalRunPipeline; 